import * as v from "valibot";

// request — CheckEpcReinstallCondition（POST, Action=CheckEpcReinstallCondition, Version 2023-01-01）
// 查询 EPC 裸金属节点底层状态是否支持发起重装。KEC 节点不调此接口。
export const RequestSchema = v.object({
  InstanceIds: v.array(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response — 返回每节点是否可重装（纯 boolean，无原因字段）
export const InstanceSetItemSchema = v.object({
  InstanceId: v.optional(v.string()),
  Reinstallable: v.boolean(),
});
export type InstanceSetItem = v.InferOutput<typeof InstanceSetItemSchema>;

export const DataSchema = v.object({
  InstanceSet: v.optional(v.array(InstanceSetItemSchema)),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  RequestId: v.string(),
  Data: v.optional(DataSchema),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
